exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customers td[data-v-a9087d2a],#customers th[data-v-a9087d2a]{border:2px solid #ddd;padding:8px;text-align:left;width:1%;white-space:nowrap}#customers tr[data-v-a9087d2a]:nth-child(2n){background-color:#f2f2f2}#customers tr[data-v-a9087d2a]:hover{background-color:#ddd}#customers th[data-v-a9087d2a]{position:sticky;top:0;padding-top:12px;padding-bottom:12px;text-align:left;background:green;color:#fff;overflow:hidden}#auto[data-v-a9087d2a]{height:70vh!important;width:100%;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a9087d2a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/package/package_list.vue
// module id = 1368
// module chunks = 3